import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { toTitleCase } from '@iotv/core-services';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { useTabHandlerStringKeys } from '../../hooks/useTabHandler';
import { ObjectViewType } from '../../types';
import DataTableView from '../../v2/components/generic/ObjectsDataTable/DataTableViewV3';
import { WideawakeView } from './tabs/Wideawake/WideawakeView';
export const DeviceManagementView = (props) => {
    const tabsToDisplay = {
        Wideawake: _jsx(WideawakeView, {}),
        Datastore: (_jsx(DataTableView, { ...props,
            columnVisibilityReferences: {
                dataTableReference: 'DeviceManagementView',
                viewType: ObjectViewType.List,
                externalColumnVisibility: undefined,
                objectTypeId: 'Device',
            } })),
    };
    const { state: [[tabValue]], handlers: { handleTabChange }, } = useTabHandlerStringKeys(tabsToDisplay);
    return (_jsxs(TabContext, { value: tabValue, children: [_jsx(TabList, { onChange: handleTabChange, children: Object.entries(tabsToDisplay)
                    .filter(([_, element]) => element !== null)
                    .map(([tabName, _], i) => (_jsx(Tab, { value: tabName, label: toTitleCase(tabName), disabled: false }, `tabHeader_${i}`))) }), Object.entries(tabsToDisplay)
                .filter(([_, c]) => c !== null)
                .map(([k, component]) => (_jsx(TabPanel, { value: k, sx: { padding: 0, paddingBlockStart: 1 }, children: component }, `tabBase_${k}`)))] }));
};
